// extracted by mini-css-extract-plugin
module.exports = {"link":"ProtectedLink_link__3V-6W","disabled":"ProtectedLink_disabled__3mipl"};